// extracted by mini-css-extract-plugin
module.exports = {"nameStampText":"_3CmctNMnHtV65_yUJBDjbd","nameStampMine":"_1ORWRNt3oCH20nQq3uLqCR","nameStampNone":"yQQuOCYLK4Gg8kjnfd0VH","nameStampNotMine":"u2bg_KYAhlIFByux-u_Yd"};